type RowNodeLike = {
    data?: unknown;
    rowPinned?: string | null;
};

type RowModelLike = {
    getType?: () => string;
    getRowCount?: () => number;
    isLastRowIndexKnown?: () => boolean;
};

export type ActiveRowCountApi = {
    getModel?: () => RowModelLike | undefined;
    forEachNodeAfterFilter?: (callback: (node: RowNodeLike) => void) => void;
};

/** Filtered row count, or null when an infinite model's total is still an estimate. */
export function getActiveRowCount(api: ActiveRowCountApi): number | null {
    const model = api.getModel?.();
    if (model?.getType?.() === 'infinite') {
        if (!model.isLastRowIndexKnown?.()) {
            return null;
        }
        return model.getRowCount?.() ?? 0;
    }

    let count = 0;
    api.forEachNodeAfterFilter?.((node) => {
        if (node.rowPinned || node.data == null) {
            return;
        }
        count += 1;
    });
    return count;
}

/** Singular label, or explicit one/other forms when pluralization is not "add s". */
export type ActiveRowCountLabel = string | { one: string; other: string };

export function formatActiveRowCount(count: number, label: ActiveRowCountLabel = 'row'): string {
    const one = typeof label === 'string' ? label : label.one;
    const other = typeof label === 'string' ? `${label}s` : label.other;
    return `${count.toLocaleString()} ${count === 1 ? one : other}`;
}
